import { useParams } from 'react-router-dom';
import { ReturnLayout } from '@/general';
import LoginForm from './components/LoginForm';
import styles from './index.module.css';

export const ReturnLoginPage = () => {
  const { storeName } = useParams();

  return (
    <ReturnLayout>
      <h1>
        {storeName}
      </h1>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <LoginForm />
        </div>
      </div>
    </ReturnLayout>
  );
};
